module.exports = {
  "report": {
    "evaluationReport": "测评报告",
    "evaluationUser": "测评用户",
    "evaluationResults": "测评结果",
    "evaluationScore": "测评分数",
    "riskLevel": "预警等级",
    "greenWarning": "绿色预警",
    "yellowWarning": "黄色预警",
    "orangeWarning": "橙色预警",
    "redWarning": "红色预警",
    "scoreRange": "得分范围",
    "evaluationResults2": "评定结果",
    "resultDescription": "结果描述",
    "interventionPlan": "建议",
    "factorAnalysis": "因子分析",
    "reportList": "我的报告",
    "evalutaionScale": "测评量表",
    "judgmentRulesOption7": "大于",
    "judgmentRulesOption8": "小于",
    "judgmentRulesOption9": "等于",
    "judgmentRulesOption10": "大于等于",
    "judgmentRulesOption11": "小于等于",
    "judgmentRulesOption12": "不等于",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/report/en.js